import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "@/shared/layouts/auth-layout";
import { AuthCallbackPage } from "@/shared/pages/auth/callback";

export const Route = createFileRoute("/auth/callback")({
  component: AuthCallbackRoute,
});

function AuthCallbackRoute() {
  return (
    <AuthLayout>
      <AuthCallbackPage />
    </AuthLayout>
  );
}
